import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import {
  MutationCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import AppRoutes from "./routes/AppRoutes";

import "react-toastify/dist/ReactToastify.css";

// Defaults for every query:
// - staleTime: reuse data for 30s instead of refetching on every mount
// - no refetch on window focus (it could reset a form someone is editing)
// - retry only server/network errors, never 4xx (401/403/404 won't change on retry)
// - any successful action (check-in, leave, asset, DTR, seminar…) can change the
//   My view dashboard, so mark it stale; it refetches when next shown
const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["me:dashboard"] }),
  }),
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const status = error?.response?.status;
        if (status && status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});

function App() {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <AppRoutes />
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;
